import { useEffect, useState } from "react";

export const AnimatedDots = () => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {Array.from({ length: dotCount }).map((_, index) => (
        <span key={index} className="text-primary">
          .
        </span>
      ))}
    </>
  );
};
